import { useEffect, useState } from 'react';

/**
 * Tarayıcının çevrimiçi/çevrimdışı durumu.
 *
 * `navigator.onLine` yalnız "ağ arayüzü var mı" sorusunu yanıtlar; sunucuya
 * erişim ayrıca başarısız olabilir. Yine de bağlantı tamamen koptuğunda
 * kullanıcıya spinner yerine açıklayıcı bir durum göstermek için yeterlidir.
 */
export function useOnlineStatus(): boolean {
  const [online, setOnline] = useState<boolean>(() => {
    if (typeof navigator === 'undefined') return true;
    return navigator.onLine;
  });

  useEffect(() => {
    const handleOnline = (): void => setOnline(true);
    const handleOffline = (): void => setOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return online;
}
